import { render, staticRenderFns } from "./EdocSettings.vue?vue&type=template&id=59ad5668"
import script from "./EdocSettings.vue?vue&type=script&lang=js"
export * from "./EdocSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports